import { Modal, Stack, Text, Textarea } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type Props = {
  form: UseFormReturnType<any>
  opened: boolean
  onClose: () => void
  onSubmit: () => void
}

export function RejectionModal({ form, opened, onClose, onSubmit }: Props) {
  const { t } = useTranslation("certificates")
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("modal.rejectModal.title")}
    >
      <Stack>
        <InfoBox
          title={t("modal.rejectModal.title")}
          message={t("modal.rejectToolTips")}
          size="xs"
        />
        <Text>{t("modal.rejectModal.subtitle")}</Text>

        <Textarea
          size="xs"
          label={t("modal.labels.rejectionMessage")}
          placeholder={t("modal.placeholders.rejectionMessage")}
          withAsterisk={true}
          styles={{
            input: {
              backgroundColor: "white",
              border: "1px solid var(--mantine-color-primary-1)",
            },
          }}
          {...form.getInputProps("rejectionMessage")}
        />
        <Button
          fullWidth={true}
          variant="primary-critical"
          color="red"
          onClick={() => {
            if (
              !form.values.rejectionMessage ||
              form.values.rejectionMessage.length === 0
            ) {
              form.setFieldError(
                "rejectionMessage",
                t("modal.rejectModal.formError")
              )
            } else {
              form.setFieldValue("status", "REJECTED")
              onSubmit()
            }
          }}
        >
          {t("modal.rejectModal.submit")}
        </Button>
      </Stack>
    </Modal>
  )
}
